<template>
  <div style="margin-top:5px;border: 1px solid #ddd;border-bottom:0px;">
    <mw-dialog size="mini_mini" :appendToBody="true" :title="$lang('请编辑纸质附件名称')" ref="pageDialog" :footerButton="footerButton">
      <div style="padding-top:5px;">
        <el-input v-model="paperItems" :rows="6"  type="textarea" :placeholder="$lang('请输入内容')"></el-input>
        <div style="font-size:15px;color:red;padding-top:5px;">{{$lang("多个附件请按回车换行！")}}</div>
      </div>
    </mw-dialog>

    <mw-dialog size="mini_mini" :appendToBody="true" :title="$lang('附件发送设置')" ref="sendDialog" :footerButton="sendFooterButton">
      <div style="padding-top:5px;">

      </div>
    </mw-dialog>
    <div style="background-color: #ececec;line-height:35px;padding-left:5px;">
      {{$lang("附件列表")}}：<el-button @click="showAttachment($event)"><i class="fa fa-paperclip"></i>{{$lang("附件管理")}}</el-button>
      <el-button @click="showPaper($event)" v-show="showPager && editMode"><i class="fa fa-paperclip" ></i>{{$lang("纸质附件")}}</el-button>
      <el-button @click="showSend($event)" v-show="showSet"><i class="fa fa-paperclip" ></i>{{$lang("附件发送设置")}}</el-button>

      <el-button icon="fa fa-chevron-up" v-if="showTable" @click="showTable =!showTable" style="float:right;background:none;border:none;margin-top: 2px;padding:7px 3px"></el-button>
      <el-button icon="fa fa-chevron-down" v-else @click="showTable =!showTable" style="float:right;background:none;border:none;margin-top: 2px;padding:7px 3px"></el-button>
    </div>
    <div style="width:100%;" v-show="showTable">
      <mw-table :data='attachData' :columns="attachColumns" :pagination="false" ref="attachTable"
                :defaultParams="attachDefaultParams" :defaultParamsAutoLoad="true"  :autoLoad="false"></mw-table>
    </div>
  </div>

</template>
<script>
  export default
  {
    name:'form-attachment-list',
    data() {
      let me=this;
      return {
        paperItems:'',
        tableData:undefined,
        editMode:!this.$options.config.getCurrentObject().isTextMode(),
        batchId:this.$options.config.getFormObject().batchId||"",
        attachApi:'business.listAttachment',
        attachDefaultParams:{},
        attachData:[],
        attachColumns: [
          {type: 'index'},
          {prop: 'name', label: $lang('名称'),formatter:me.attachNameFormatter},
          {prop: 'creator', label: $lang('上传者'),width: '120'},
          {prop: 'createTime', label: $lang('上传日期'),width: '170'},
          {prop: 'size', label: $lang('大小'),width: '120',formatter:me.attachFormatter}
        ],
        footerButton: [{
          label: $lang('确定'),
          func: this.paperSure
        }, {
          label: $lang('取消'),
          func: this.paperCancel
        }],
        sendFooterButton: [{
          label: $lang('确定'),
          func: this.sendSure
        }, {
          label: $lang('取消'),
          func: this.sendCancel
        }],
        // 折叠表格面板
        showTable:true,
        showPager: true,
        showSet:true,
      }
    },
    created() {
      let config = this.$options.config.getConfig();
      this.showPager=config.pager!==false;
      this.showSet=config.sendSet!==false;
      if(this.$options.params.taskData && this.$options.params.taskData.finishTime){
         this.showPager=false;
         this.showSet=false;
      }

    },
    mounted() {
      this.refreshAttachment(this.$options.params.attachmentData);
    },
    methods: {
      paperSure(){
        if(this.$options.config.getForm())
          this.$options.config.getForm().setValueByName('addpaperattachment',this.paperItems);//纸质附件
        this.refreshAttachment(this.tableData);
        this.mwRef('pageDialog').hide();
      },
      paperCancel(){
        this.mwRef('pageDialog').hide();
      },

      showPaper(e){
        if(this.$options.config.getForm()){
          try{
            this.paperItems=this.$options.config.getForm().getValueByName('addpaperattachment');
          }catch (ex){}
        }
        this.mwRef('pageDialog').show();
      },
      sendSure(){
        this.mwRef('sendDialog').hide();
      },
      sendCancel(){
        this.mwRef('sendDialog').hide();
      },
      showSend(e){
        let me=this;
        let formData;
        let form=this.$options.config.getForm();
        if(this.$options.config.getForm().getExtForm())
          formData=this.$options.config.getForm().getExtForm().formData;
        if(!formData){
          PF.message('warning',$lang('取不到表单值'));
          return
        }
        let fldzs=formData.fldzs;//主送
        if(!fldzs){
          PF.message('warning',$lang('请选择主送'));
          return
        }
        let formSel=formData.addattachsend;
        if(formSel){//发送的值
          formSel=PF.decode(formSel);
          if(formSel.orgs){
            formSel.deptObjs={};
            formSel.orgs.forEach(v=>{
              formSel.deptObjs[v.id]=v;
            })
          }
        }

        let flddfbmstn=formData.flddfbmstn; //人员、部门名称
        let flddfbmstnbmids=formData.flddfbmstnbmids; //部门IDS
        let fldgwnfbms=formData.fldgwnfbms;//部门名称
        let flddfbmstnryids=formData.flddfbmstnryids||""; //人员IDS
        let flddgwnfrys=formData.flddgwnfrys;//人员名称

        let fldzsbmIds=formData.fldzsbmIds; //主送部门IDS
        let fldzsbmNames=formData.fldzsbmNames; //主送部门名称
        let fldzsryIds=formData.fldzsryIds; //主送人员IDS
        let fldzsryNames=formData.fldzsryNames; //主送人员名称
        let fldcsbmIds=formData.fldcsbmIds; //抄送部门IDS
        let fldcsbmNames=formData.fldcsbmNames; //抄送部门名称
        let fldcsryIds=formData.fldcsryIds; //抄送人员IDS
        let fldcsryNames=formData.fldcsryNames; //抄送人员名称
        if(!flddfbmstn){
              if(!flddfbmstnbmids){
                  let bmids=[];
                  if(fldzsbmIds){
                    bmids=bmids.concat(fldzsbmIds.split(','));
                  }
                  if(fldcsbmIds) {
                    bmids=bmids.concat(fldcsbmIds.split(','));
                  }
                  if(bmids.length>0)
                    flddfbmstnbmids=bmids.join(",");
              }

              if(!flddfbmstnryids){
                let ryIds=[];
                if(fldzsryIds){
                  ryIds=ryIds.concat(fldzsryIds.split(','));
                }
                if(fldcsryIds) {
                  ryIds=ryIds.concat(fldcsryIds.split(','));
                }
                if(ryIds.length>0)
                flddfbmstnryids=ryIds.join(",");
              }
        }
        if(!flddfbmstnryids && !flddfbmstnbmids){
          me.mwMsg('warning',$lang('请选择主送或抄送'));
          return;
        }


        let id=flddfbmstnryids||"";
        if(flddfbmstnbmids){
          if(id){
            id=id+','+flddfbmstnbmids;
          }else{
            id=flddfbmstnbmids;
          }
        }
        if(!flddfbmstn){
          let dfmstn=[];
          if(fldzsryNames)
             dfmstn=dfmstn.concat(fldzsryNames.split(','));
          if(fldcsryNames)
             dfmstn=dfmstn.concat(fldcsryNames.split(','));
          if(fldzsbmNames)
            dfmstn=dfmstn.concat(fldzsbmNames.split(','));
          if(fldcsbmNames)
            dfmstn=dfmstn.concat(fldcsbmNames.split(','));
          if(dfmstn.length>0)
            flddfbmstn=dfmstn.join(",");
        }else{
             let dfmstn=[];
             if(flddgwnfrys)
               dfmstn=dfmstn.concat(flddgwnfrys.split(','));
             if(fldgwnfbms)
               dfmstn=dfmstn.concat(fldgwnfbms.split(','));
            if(dfmstn.length>0)
             flddfbmstn=dfmstn.join(",");
        }

        let ids=id.split(',');
        let names=flddfbmstn.split(',');
        let dept={};
        let idx=0;
        ids.forEach(v1=>{
          if(flddfbmstnryids && flddfbmstnryids.indexOf(v1)>-1){
            dept[v1]={id:v1,name:names[idx],type:'ry',files:[]};
          }else{
            dept[v1]={id:v1,name:names[idx],type:'bm',files:[]};
          }
          idx++;
        })

        let val={};//附件{部门、人员}

        me.tableData.forEach(v=>{
          let obj=[];
          idx=0;
          if(formSel && formSel.fileIds && (formSel.fileIds.indexOf(v.id)>-1)){ //选有附件
            ids.forEach(v1=>{
              if(flddfbmstnryids && flddfbmstnryids.indexOf(v1)>-1){
                if(formSel.deptObjs && (formSel.deptObjs[v1] && (formSel.deptObjs[v1].files.indexOf(v.id)==-1))){
                  obj.push({id:v1,name:names[idx],type:'ry',sel:false});
                }else{
                  obj.push({id:v1,name:names[idx],type:'ry',sel:true});
                }
              }else{
                if(formSel.deptObjs && (formSel.deptObjs[v1] && (formSel.deptObjs[v1].files.indexOf(v.id)==-1))){
                  obj.push({id:v1,name:names[idx],type:'bm',sel:false});
                }else{
                  obj.push({id:v1,name:names[idx],type:'bm',sel:true});
                }
              }
              idx++;
            })
          }else{
            ids.forEach(v1=>{
              if(flddfbmstnryids && flddfbmstnryids.indexOf(v1)>-1){
                obj.push({id:v1,name:names[idx],type:'ry',sel:true});
              }else{
                obj.push({id:v1,name:names[idx],type:'bm',sel:true});
              }
              idx++;
            })
          }
          val[v.id]=obj;
        })
        let selData;
        let selId="";
        PF.show('treeTable', {
          showTreeToolbar:false,
          treeAsync:false,
          treeData:me.tableData,
          size:'small_large',
          selectFirst: true, clearBtn: false, title: $lang('请选择'),
          columns: [{type: 'selection'},
            {prop: 'name',label: $lang('部门或用户'),tooltip: true}],
          singleSelect:false,
          changed:function(value,tree,table){
            if(selId==value.id){
              return;
            }
            selId=value.id;
            selData=val[value.id];
            setTimeout(function() {
              table.setData(selData, function () {
                selData.forEach(v => {
                  if (v.sel) {
                    table.selectByProp('id', v.id);
                  }
                })
              });
            },500);
          },
          selectAll:function(selection){
            if(selection.length>0){
              selection.forEach(v=>{
                v.sel=true;
              })
            }else{
              selData.forEach(v=>{
                v.sel=false;
              })
            }
          },
          select:function(selection, row){
            row.sel=!row.sel;
          },
          rowClick:function(row, event, column){
            row.sel=!row.sel;
          },
          autoLoad:true,
          tableData:[],
        }, function (res) {
          let send={};
          let keys=me.mwLodash.keys(val);
          send.fileIds=[];
          keys.forEach(k=>{
            send.fileIds.push(k);
            val[k].forEach(v=>{
              if(v.sel)
                dept[v.id].files.push(k);
            })
          })
          let orgs=[];
          keys=me.mwLodash.keys(dept);
          keys.forEach(k=>{
            orgs.push(dept[k]);
          })
          send.orgs=orgs;
          form.setValueByName('addattachsend',PF.encode(send));
        });
      },

      attachFormatter(row, column, cellValue){
        if(cellValue){
          return (cellValue/1024).toFixed(2)+'K';
        }
      },
      attachNameFormatter(row, column, cellValue){
        let me=this;
        if(row.category!=undefined && row.category=='pager')
          return (<span>{cellValue}</span>);
        else
          return (<span class="attach-down" onClick={(event)=>{me.downLoadAttach(row)}}>{cellValue}</span>);
      },
      downLoadAttach(data){
        var me=this;
        let params={}
        params.id=data.id;
        params.businessId=this.$options.params.businessId;
        params.formId=this.$options.params.formId;
        params.tempBusinessId=this.$options.params.tempBusinessId;
        params.editMode=me.editMode;
        params.batchId=me.batchId;
        if(window.PF&&PF.action&&PF.action["attachment_preview"]){
          let formObj=me.$options.config.getForm?me.$options.config.getForm():{};
          PF.action["attachment_preview"](params,formObj,me);
          return;
        }
        //商秘系统需要把附件下载功能关掉
        if(this.isCloseAttachDownload()) return;
        me.mwApi.business.downloadAttachment(params);
      },
      showAttachment(event){
        event.stopPropagation();
        // if(/(msie\s|trident.*rv:)([\w.]+)/.exec(navigator.userAgent.toLowerCase()) != null){
        //   PF.show('NtkoAttachment',{businessId:this.$options.params.businessId,tempBusinessId:this.$options.params.tempBusinessId,formId:this.$options.params.formId,editable:this.editMode},this.refreshAttachment);
        // }else{
          let closeAttachDownload = this.isCloseAttachDownload();
          let fullAuthType="";
        if(this.$options.config.getForm().getExtForm())
            fullAuthType=this.$options.config.getForm().getExtForm().extParams.fullAuthType||"";
          PF.show('attachment',{type:"JOA_FJ",businessId:this.$options.params.businessId,tempBusinessId:this.$options.params.tempBusinessId,formId:this.$options.params.formId,batchId:this.batchId,editable:this.editMode,closeAttachDownload:closeAttachDownload,recordsIsCanEdit:this.recordsIsCanEdit,fullAuthType:fullAuthType},this.refreshAttachment);
       // }
        //PF.show('attachment',{businessId:this.$options.params.businessId,tempBusinessId:this.$options.params.tempBusinessId,formId:this.$options.params.formId,editable:!this.$options.params.formReadOnly},this.refreshAttachment);
      },
      recordsIsCanEdit:function(rows){
        let me = this;
        if(window.PF&&PF.action&&PF.action.formAttachmentIsCanEdit){
          return PF.action.formAttachmentIsCanEdit(me.$options.config,rows);
        }else{
          return true;//默认显示
        }
      },
      isCloseAttachDownload(){
        let formObj = this.$options.config.getFormObject();
        let closeAttachDownload = false;
        if(formObj && formObj.type=="module_flow"){
          let sysConfig = formObj.$store.getters.sysConfig;
          if(sysConfig && sysConfig.closeAttachDownload){
            if(!(!_.isEmpty(formObj.activity) && (formObj.activity.downloadAttach == undefined || formObj.activity.downloadAttach==1))){
              closeAttachDownload = true;
            }
          }
        }
        return closeAttachDownload;
      },
      showNtkoEditor(event){
        event.stopPropagation();

        var par = {
          editable:this.editMode,
          formConfig:this.$options.config.getConfig(),  //获取控件的配置信息
          form:this.$options.config.getForm(),
          processActivity:this.$options.config.getFormObject().activity,  //流程信息
          moduleId:this.$options.params.moduleId,
          businessId:this.$options.params.businessId,
          tempBusinessId:this.$options.params.tempBusinessId,
          formId:this.$options.params.formId,
          formData:this.$options.config.getFormValue(),
          isShowToolbar: true
        }
        PF.show('NtkoEditor',par,this.refreshAttachment);
      },
      createCLD(event){
        event.stopPropagation();
        var p={
          editable:this.editMode,
          formConfig:this.$options.config.getConfig(),  //获取控件的配置信息
          form:this.$options.config.getForm(),
          processActivity:this.$options.config.getFormObject().activity,  //流程信息
          moduleId:this.$options.params.moduleId,
          businessId:this.$options.params.businessId,
          tempBusinessId:this.$options.params.tempBusinessId,
          formId:this.$options.params.formId,
          formData:this.$options.config.getFormValue()
        }
        PF.show('CreateCLD',p,this.refreshAttachment);
      },
      readCLD(event){
        event.stopPropagation();
        var p={
          editable:false,
          formConfig:this.$options.config.getConfig(),  //获取控件的配置信息
          form:this.$options.config.getForm(),
          processActivity:this.$options.config.getFormObject().activity,  //流程信息
          moduleId:this.$options.params.moduleId,
          businessId:this.$options.params.businessId,
          tempBusinessId:this.$options.params.tempBusinessId,
          formId:this.$options.params.formId,
          formData:this.$options.config.getFormValue()
        }
        PF.show('readCLD',p,this.refreshAttachment);
      },
      printCLD(event){
        event.stopPropagation();
        var p={
          editable:false,
          formConfig:this.$options.config.getConfig(),  //获取控件的配置信息
          form:this.$options.config.getForm(),
          processActivity:this.$options.config.getFormObject().activity,  //流程信息
          moduleId:this.$options.params.moduleId,
          businessId:this.$options.params.businessId,
          tempBusinessId:this.$options.params.tempBusinessId,
          formId:this.$options.params.formId,
          formData:this.$options.config.getFormValue()
        }
        PF.show('printCLD',p,this.refreshAttachment);
      },


      refreshAttachment(data){
        if(data==undefined){
          return
        }
        this.tableData=data;
        let ndata=[];
        data.forEach(v=>{
          if(v.category==undefined || v.category!='pager')
            ndata.push(v);
        })
        let addpaperattachment=this.$options.config.getForm().getValueByName('addpaperattachment');
        if(addpaperattachment!=undefined && addpaperattachment!='' ){
          let paper=addpaperattachment.split('\n');
          paper.forEach(v=>{
            ndata.push({id:v,name:'【纸质附件】'+v,category:'pager'});
          })
        }
        if (ndata && ndata.length>0 && window.$currentBrowserLanguage === 'en') {
          ndata.forEach(d => {
            d.creator=d.Englishname || d.creator;
          });
        }
        this.mwRef('attachTable').setData(ndata);
        this.$emit("refreshAttachment",this,ndata);
      },
      onChange(name,value,d) {
        if (name === "pager") {
          //显示或者隐藏纸质附件按钮
          this.showPager=value;
        }
        if (name === "sendSet") {
          //显示或者隐藏发送设置按钮
          this.showSet=value;
        }
      }
    },
    destroyed(){

    }
  }
</script>



// WEBPACK FOOTER //
// src/common/components/extend/form/src/components/attachment.vue